<template>
  <div class="containerTable">
    <vxe-toolbar id="toolbarId_re4" :custom="{ storage: true }" export :refresh="{ query: findList }">
      <template v-slot:buttons>
        <el-button  @click="funcFilter">
          查询
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      highlight-hover-row
      highlight-current-row
      row-id="id"
      height="80%"
      :loading="loading"
      :data="tableData"
      show-footer
      :footer-method="footerMethod"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      class="mytable-style"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column field="name" title="驾驶员姓名" min-width="200" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.name" placeholder="请输入" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="phone" title="联系方式" min-width="200" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.phone" placeholder="请输入联系方式" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="identificationNumber" title="身份证号" min-width="200" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.identificationNumber" placeholder="请输入身份证号" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="idCardDueDate" title="身份证到期日期" min-width="360" sortable />
        <template v-slot:header>
          <el-date-picker
            v-model="driverLicenseDueDateRange4"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'idCardDueDate')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="vehicleClass" title="准驾类型" min-width="200" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.vehicleClass" placeholder="请输入准驾类型" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="workLicense" title="道路运输从业资格证号" min-width="220" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.workLicense" placeholder="请输入道路运输从业资格证号" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="workLicenseDueDate" title="道路运输从业资格证号到期日期" min-width="360" sortable />
        <template v-slot:header>
          <el-date-picker
            v-model="driverLicenseDueDateRange3"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'workLicenseDueDate')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="driverLicenseDueDate" title="驾驶证到期日期" min-width="360" sortable />
        <template v-slot:header>
          <el-date-picker
            v-model="driverLicenseDueDateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'driverLicenseDueDate')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="gmtCreated" min-width="360" title="注册时间" sortable />
        <template v-slot:header>
          <el-date-picker
            v-model="gmtCreatedRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" min-width="100" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            content="比对"
            placement="top"
          >
            <vxe-button type="text" @click="funcEdit(scope.row.code,scope.row.driverType)">
              <i class="el-icon-s-operation" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
      @page-change="handlePageChange"
    />
    <vxe-modal v-model="driverFlag" title="实际承运人比对" width="1200" height="80%" resize @close="initDriver">
      <driverDetail ref="detailRef" :parent-data="parentData" @fatherMethods="fatherMethods" />
    </vxe-modal>
  </div>
</template>
<script>
	import {
		driverCompareList
	} from "@/api/driver";
	
	import driverDetail from "./components/driverDetail.vue";
	export default {
		name: "CarrierReview",
		components:{
			driverDetail
		},
		data() {
			return {
				isCtms: true, //默认显示  同城系统隐藏
				modelTtile: '详情',
				parentData: {
					model: 'detail',
					isDetail: true,
					areaOptions: [],
					receiverUserCodeOptions: [],
					typeOptions: [],
					bankOptions: []
				},
				exportableQuantity: localStorage.getItem('exportableQuantity'),
				exportableUrl: 'ntocc-basic-api/driver/exportTeamDriverAuth',
				driverLicenseDueDateRange: "",
				driverLicenseFromDateRange: "",
				driverLicenseDueDateRange3: '',
				gmtCreatedRange: "",
				loginkTarget: 0,
				loading: false,
				tableData: [],
				driverFlag: false,
				datagramFlag: false,
				driverLicenseDueDateRange4: '',
				listQuery: {
					pageNum: 1,
					pageSize: 20,
					sortField: "",
					sortType: "",
					total: 0
				},
				Pagingconf: [],
				sumObject: {
					balance: 0
				},
			};
		},
		computed: {
			model() {
				return this.parentData.model
			}
		},
		watch: {
			$route(to, from) {
				const v = to.query.todo;
				if (v) {
					this.listQuery.authStatusExt = 0;
				} else {
					this.listQuery.authStatusExt = "";
				}
				this.findList();
			},
			model(val) {
				this.modelTtile = val === 'review' ? '审核' : '详情'
			}
		},

		created() {
			this.findList();
		},
		methods: {
			findList() {
				this.loading = true;
				return new Promise(resolve => {
					driverCompareList(this.listQuery).then(response => {
						this.tableData = response.data.records;
						this.listQuery.total = response.data.total;
						response.data.total > 10000 ? this.Pagingconf = [20, 30, 50, 100, 10000] : this
							.Pagingconf = [20, 30, 50, 100, response.data.total || 1];
						this.sumObject = response.data.sumObject;
						this.loading = false;
						resolve();
					});
				});
			},
			// 查询
			funcFilter() {
				this.listQuery.pageNum = 1;
				this.findList();
			},
			// 排序
			sortList({
				column,
				property,
				order
			}) {
				if (order) {
					this.listQuery.sortField = property;
					this.listQuery.sortType = order;
				} else {
					this.listQuery.sortField = "";
				}
				this.findList();
			},
			// 详情
			funcEdit(code, prefix) {
				this.driverFlag = true;
				this.$refs.detailRef.getDriver(code);
				this.$set(this.parentData, 'driverType', prefix)
			},
			fatherMethods() {
				this.driverFlag = false;
				this.initDriver()
				this.findList();
			},
			initDriver(){
				this.$refs.detailRef.funcInit();
			},
			// 翻译审核状态
			formatterAuthStatus({
				cellValue
			}) {
				const item = this.authStatusOptions.find(
					item => item.value === cellValue
				);
				return item ? item.label : "";
			},
			// 时间
			changeDate(value, prefix) {
				if (value) {
					this.listQuery[`${prefix}Start`] = value[0] + " 00:00:00";
					this.listQuery[`${prefix}End`] = value[1] + " 23:59:59";
				} else {
					this.listQuery[`${prefix}Start`] = "";
					this.listQuery[`${prefix}End`] = "";
				}
			},
			
			// 分页handle
			handlePageChange({
				currentPage,
				pageSize
			}) {
				this.listQuery.pageNum = currentPage;
				this.listQuery.pageSize = pageSize;
				this.findList();
			},
			// 设置底部合计
			footerMethod({
				columns,
				data
			}) {
				return [
					columns.map((column, columnIndex) => {
						if (columnIndex === 0) {
							return "合计";
						}
						if (column.property === "balance") {
							return this.$XEUtils.sum(data, column.property);
						}
						return "-";
					})
				];
			},
			checCheckboxkMethod2({
				row
			}) {
				return row.isSendLoginkExt != 1
			}
		}
	};
</script>
<style scoped>
	.mytable-style .vxe-body--column.col-red {
		background-color: red;
		color: #fff;
	}
